import React, { useEffect, useState } from "react";
import "./allNotification.css";
import like from "../../assets/images/Like1.png";
import comment from "../../assets/images/Comment1.png";
import Loading from "../../assets/images/loading.gif";
import star from "../../assets/images/Star1.png";
import { useHistory } from "react-router";
import InfiniteScroll from "react-infinite-scroll-component";

//For Later Use
import post from "../../assets/images/Post1.png";

function AllNotify() {
  const history = useHistory();
  const [notiMessage, setNotiMessage] = useState(["loading"]);
  const [more, setMore] = useState(true);
  const [limit, setLimit] = useState(15);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = () => {
    fetch(
      process.env.REACT_APP_API_URL + "api/posts/notifications/" + limit + "/0"
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful == true) {
          setNotiMessage(data.notification);
          setOffset(limit);
        }
      });
  };

  const fetchMoreData = () => {
    fetch(
      process.env.REACT_APP_API_URL +
      "api/posts/notifications/" +
      limit +
      "/" +
      offset
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful == true) {
          //setNotiMessage(data.notification);
          //console.log(notiMessage);
          setNotiMessage(notiMessage.concat(data.notification));
          if (data.notification.length < limit) {
            setMore(false);
          } else {
            setOffset(offset + limit);
          }
        }
      });
  };
  function PostItem() {
    // useEffect(() => {
    //   fetchInitialData();
    // }, []);
    if (notiMessage == "loading") {
      return (
        <div className="loading-image">
          <img src={Loading}></img>
        </div>
      );
    } else {
      if (notiMessage.length > 0) {
        return notiMessage.map((element, index) => {
          return (
            <>
              <div key={index}
                className={` hd-allnotify-menu ${element.IsSeen == 0 ? "Seen" : null
                  }`}
              >
                <div
                  className="hd-allnotify-menu-mi"
                  onClick={(e) => history.push("/post/" + element.PostID)}
                >
                  <div className="hd-allnotify-menu-img">
                    <img
                      src={
                        process.env.REACT_APP_IMG_URL +
                        (element.UserImage ? element.UserImage : "no-img.png")
                      }
                    />
                    <div className="hd-allnotify-type">
                      <img
                        src={
                          element.NotificationType == "Like"
                            ? like
                            : element.NotificationType == "Comment"
                              ? comment
                              : star
                        }
                      />
                    </div>
                  </div>
                  <div className="hd-allnotify-menu-txt">{element.Message}</div>
                  <div className="hd-allnotify-time">
                    {element.formattedDate}
                  </div>
                </div>
              </div>
            </>
          );
        });
      } else {
        return (
          <div className="hd-allnotify-menu">
            <div className="hd-allnotify-menu-mi nonoti">
              <div className="hd-allnotify-menu-txt nonoti">
                <b>No Notification Found</b>
              </div>
            </div>
          </div>
        );
      }
    }
  }
  return (
    <div className="hd-allnotify">
      <InfiniteScroll
        dataLength={notiMessage.length}
        next={fetchMoreData}
        hasMore={more}
        refreshFunction={fetchInitialData}
      >
        {PostItem()}
      </InfiniteScroll>
    </div>
  );
}

export default AllNotify;
